import { render, staticRenderFns } from "./SelectFilterComponent.vue?vue&type=template&id=28b3dc28&lang=pug"
import script from "./SelectFilterComponent.vue?vue&type=script&lang=js"
export * from "./SelectFilterComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectFilterComponent.vue?vue&type=style&index=0&id=28b3dc28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports